export const errorHandler = (
  error,
  fallbackMessage = "Unable to connect to Advancly services."
) => {
  if (error?.message?.toLowerCase() === "network error") {
    return "Unable to connect to Advancly services.";
  }

  return (
    error?.response?.data?.message ||
    error?.response?.data?.data?.message ||
    error?.data?.message ||
    error?.message ||
    fallbackMessage
  );
};
